const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getDeviceInfo() {
  const ua = navigator.userAgent;
  let browser = 'Other';
  if (navigator.brave) browser = 'Brave';
  else if (/Edg\//.test(ua)) browser = 'Edge';
  else if (/OPR\//.test(ua)) browser = 'Opera';
  else if (/SamsungBrowser/.test(ua)) browser = 'Samsung Internet';
  else if (/Firefox\//.test(ua)) browser = 'Firefox';
  else if (/Chrome\//.test(ua)) browser = 'Chrome';
  else if (/Safari\//.test(ua)) browser = 'Safari';
  return {
    browser,
    os: /Windows/.test(ua) ? 'Windows' : /Mac OS/.test(ua) ? 'macOS' : /Android/.test(ua) ? 'Android' : /iPhone|iPad/.test(ua) ? 'iOS' : /Linux/.test(ua) ? 'Linux' : 'Other',
    device_type: /Mobi|Android/i.test(ua) ? 'mobile' : /Tablet|iPad/i.test(ua) ? 'tablet' : 'desktop',
    screen: `${window.screen.width}x${window.screen.height}`,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    pixel_ratio: window.devicePixelRatio || 1,
    user_agent: ua,
    language: navigator.language || '',
    platform: navigator.platform || '',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
    installed_pwa: window.matchMedia?.('(display-mode: standalone)')?.matches || window.navigator.standalone === true || false,
    online: navigator.onLine,
    touch_points: navigator.maxTouchPoints || 0,
  };
}

// ---- Session canary: detects unexpected token loss (e.g. browser clearing storage) ----
export function markSessionActive() {
  try {
    localStorage.setItem('ccc-session-active', '1');
    document.cookie = 'ccc_canary=1; max-age=31536000; path=/; SameSite=Lax';
  } catch (_e) { /* noop */ }
}

export function clearSessionCanary() {
  try {
    localStorage.removeItem('ccc-session-active');
    document.cookie = 'ccc_canary=; max-age=0; path=/';
  } catch (_e) { /* noop */ }
}

export function hasSessionCanary() {
  try {
    return localStorage.getItem('ccc-session-active') === '1' || document.cookie.includes('ccc_canary=1');
  } catch { return false; }
}

export function decodeTokenClaims(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return { iat: payload.iat, exp: payload.exp };
  } catch { return null; }
}

// Fire-and-forget diagnostic report for login failures.
// Uses sendBeacon so the report survives an immediate page redirect.
export function reportLoginIssue(source, errorDetail, context = {}) {
  try {
    const payload = JSON.stringify({
      source,
      error_detail: String(errorDetail || '').slice(0, 2000),
      device_info: getDeviceInfo(),
      context: { url: window.location.href.slice(0, 500), ...context },
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/auth/report-login-issue`, new Blob([payload], { type: 'application/json' }));
    } else {
      fetch(`${API}/auth/report-login-issue`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
        keepalive: true,
      }).catch(() => {});
    }
  } catch (e) { if (process.env.NODE_ENV !== 'production') console.debug('[reportLoginIssue] suppressed', e); }
}
